export const NEGATIVE_SENTIMENT_LABEL_ID = '610dc9f6-e1b5-4f0a-8a8d-9f6c011d8e79'
export const POSITIVE_SENTIMENT_LABEL_ID = '5c4e0b3e-1ea6-4e15-b1f9-d5c2f6d6db9c'
export const NEUTRAL_SENTIMENT_LABEL_ID = '2a92764e-35e2-4a44-9b38-57f6d5f68825'
